export const sideBarConfig = [
    {
        role : 0,  // admin
        components : [
            {
              "label": "Dashboard",
              "icon": "fas fa-tachometer-alt",
              "path": "/"
            },
            {
              "label": "Calendar",
              "icon": "bi bi-people",
              "path": "/calendar"
            },
            {
              "label": "Patients",
              "icon": "bi bi-file-medical",
              "path": "/list-patients"
            },
          
            {
              "label": "Revenue",
              "icon": "bi bi-cash",
              "path": "/list-expenses"
            },
            {
              "label": "Appointments",
              "icon": "bi bi-card-list",
              "path": "/patient-app-details"
            }
          ],
          settings: [
            {
              "label": "Profile",
              "icon": "bi bi-person-circle",
              "path": "/profile"
            },
            {
              "label": "Medicine",
              "icon": "fa fa-tablets",
              "path": "/list/medicine"
            },
            {
              "label": "Print",
              "icon": "bi bi-printer",
              "path": "/print-details"
            },
            {
              "label": "Treatments",
              "icon": "fa fa-hospital-user",
              "path": "/treatments"
            },
            {
              "label": "Clinical Notes",
              "icon": "bi bi-journals",
              "path": "/clinical-notes"
            },
            {
              "label": "Assign roles",
              "icon": "bi bi-user",
              "path": "/roles"
            }
          ]
    },
    {
        role : 1, //doctor
        components : [
            {
              "label": "Dashboard",
              "icon": "fas fa-tachometer-alt",
              "path": "/"
            },
            {
              "label": "Calendar",
              "icon": "bi bi-people",
              "path": "/calendar"
            },
            {
              "label": "Patients",
              "icon": "bi bi-file-medical",
              "path": "/list-patients"
            },
        
            {
              "label": "Revenue",
              "icon": "bi bi-cash",
              "path": "/list-expenses"
            },
            {
              "label": "Appointments",
              "icon": "bi bi-card-list",
              "path": "/patient-app-details"
            }
          ],
          "settings": [
            {
              "label": "Profile",
              "icon": "bi bi-person-circle",
              "path": "/profile"
            },
            {
              "label": "Medicine",
              "icon": "fa fa-tablets",
              "path": "/list/medicine"
            },
            {
              "label": "Print",
              "icon": "bi bi-printer",
              "path": "/print-details"
            },
            {
              "label": "Treatments",
              "icon": "fa fa-hospital-user",
              "path": "/treatments"
            },
            {
              "label": "Clinical Notes",
              "icon": "bi bi-journals",
              "path": "/clinical-notes"
            },
            {
              "label": "Assign roles",
              "icon": "bi bi-user",
              "path": "/roles"
            }
          ]
    },
    {
        role : 2, // staff
        components : [
            {
              "label": "Dashboard",
              "icon": "fas fa-tachometer-alt",
              "path": "/"
            },
            {
              "label": "Calendar",
              "icon": "bi bi-people",
              "path": "/calendar"
            },
            {
              "label": "Patients",
              "icon": "bi bi-file-medical",
              "path": "/list-patients"
            },
            {
              "label": "Medicine",
              "icon": "fa fa-tablets",
              "path": "/list/medicine"
            },
            {
              "label": "Revenue",
              "icon": "bi bi-cash",
              "path": "/list-expenses"
            },
            {
              "label": "Appointments",
              "icon": "bi bi-card-list",
              "path": "/patient-app-details"
            }
          ],
          "settings": [
            {
              "label": "Profile",
              "icon": "bi bi-person-circle",
              "path": "/profile"
            },
            {
              "label": "Print",
              "icon": "bi bi-printer",
              "path": "/print-details"
            },
            {
              "label": "Treatments",
              "icon": "fa fa-hospital-user",
              "path": "/treatments"
            },
            {
              "label": "Clinical Notes",
              "icon": "bi bi-journals",
              "path": "/clinical-notes"
            },
            {
              "label": "Assign roles",
              "icon": "bi bi-user",
              "path": "/roles"
            }
          ]
    },
    {
      role : 3, // patient
      components : [
          {
            "label": "Dashboard",
            "icon": "fas fa-tachometer-alt",
            "path": "/"
          },
          {
            "label": "Calendar",
            "icon": "bi bi-people",
            "path": "/calendar"
          },
          {
            "label": "Appointments",
            "icon": "bi bi-card-list",
            "path": "/patient-app-details"
          }
        ],
        settings: [
          {
            "label": "Profile",
            "icon": "bi bi-person-circle",
            "path": "/profile"
          },
          {
            "label": "Clinical Notes",
            "icon": "bi bi-journals",
            "path": "/clinical-notes"
          }
        ]
    }
]